import { createAction } from "redux-actions";
import { FETCH_CUSTOMER, GET_BALANCE } from "../constants";
import { serverFindBalancesCedule, feathersCreateData } from "./../services";
import { urlBalances } from "./../services/urls";



// export const getCustomerData = createAction(FETCH_CUSTOMER, (id, field) => feathersFindData('balances', field, id)())
export const getCustomerData = createAction(FETCH_CUSTOMER, (cedule) => feathersCreateData('core-server',{
    service: 'CLIENT',
    func: 'GET_USER',
    cedule
})())
export const getCustomerDataByCedule = createAction(FETCH_CUSTOMER, (id) => serverFindBalancesCedule(id, urlBalances)())

/// traer balance
export const getBalanceUser = createAction(GET_BALANCE, (data) => feathersCreateData('core-server',{
    service: 'ACCOUNT',
    func: 'GET_ACCOUNT_INF',
    data
})())